// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { injectCss } from "@insite/mobius/utilities";
import breakpoints from "@pace/XDL/PreStyle/breakpoints";
import React from "react";
import styled from "styled-components";

interface PictureProps {
    smallPath?: string;
    mediumPath: string;
    largePath?: string;
    altText: string;
}

const LazyPictureStyle = styled.picture<any>`
    max-height: 100%;
    max-width: 100%;
    ${injectCss}
`;

const XngPicture: React.FC<PictureProps> = (props) => {
    const { altText, smallPath, mediumPath, largePath, ...otherProps } = props;
    return (
        <LazyPictureStyle {...otherProps}>
            {!!largePath && <source media={`(min-width: ${breakpoints.values[2]}px)`} srcSet={largePath || mediumPath} />}
            {!!mediumPath && <source media={`(min-width: ${breakpoints.values[1]}px)`} srcSet={mediumPath} />}
            {!!smallPath && <source media={`(min-width: ${breakpoints.values[0]}px)`} srcSet={smallPath || mediumPath} />}
            <img src={mediumPath} alt={altText}/>
        </LazyPictureStyle>
    );
};

export default XngPicture;
